import React from 'react';
import { useContext } from 'react';
import capitalise from '../../../utils/capitalise';

import { StationDetails, Template } from '../../types';
import TrainInfoContext from '../TrainInfoContext';
import { isMobile } from '../../../utils/commonUtils';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';
import { SEO_TRAIN_PAGE } from '../../../utils/RailsSEOConstants';
type TrainHeaderProps = {
  sourceStation: StationDetails;
  destinationStation: StationDetails;
  onClick: (filterData, isMobile) => void;
  template: Template;
  trainNumber: string;
};

export default function TrainHeader({
  sourceStation,
  destinationStation,
  template,
  onClick,
  trainNumber
}: TrainHeaderProps) {
  const trainsData = useContext(TrainInfoContext);
  return (
    <>
      <section className="railSeoWrap__railTitle">
        <div className="makeFlex column w-80">
          <h1 className="railSeoWrap__railTitle--trainName">{template.h1_title}</h1>
          <p className="font12 latoBold blackText">
            {capitalise(sourceStation.stationName)} ({sourceStation.stationCode}) -{' '}
            {capitalise(destinationStation.stationName)} ({destinationStation.stationCode})
          </p>
        </div>
        <div className="desktopShow">
          <button
            className="primaryBtn bkTrnBtn"
            onClick={() => {
              trackClickEventProp61(SEO_TRAIN_PAGE, 'rail_seo_train_booktrain');
              onClick(
                {
                  sourceCityEn: sourceStation.cityEn,
                  destinationCityEn: destinationStation.cityEn,
                  sourceCity: sourceStation.city,
                  sourceStn: sourceStation.stationCode,
                  destinationCity: destinationStation.city,
                  destinationStn: destinationStation.stationCode,
                  trainNumber
                },
                isMobile()
              );
            }}
          >
            {trainsData.miscellaneous['BOOK TRAIN']}
          </button>
        </div>
      </section>
    </>
  );
}
